module.exports = __webpack_public_path__ + "static/media/034.c8687cba.jpg";